// extracted by mini-css-extract-plugin
module.exports = {"container":"highlight-module__container--lU94a"};